<template>
  <div class="page" v-loading="tableLoading">
    <el-form label-width="100px">
      <el-row>
        <el-col :span="8">
          <el-form-item label="商品skuId">
            <el-input v-model="queryForm.skuId" placeholder="请输入商品skuId"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="商品型号">
            <el-input v-model="queryForm.Model" placeholder="请输入商品型号"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="仓库名">
            <el-input v-model="queryForm.warehouseName" placeholder="请输入仓库名"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <div class="grid-content bg-purple"></div>
        </el-col>
      </el-row>
      <el-form-item>
        <div class="flex">
          <el-button type="primary" @click="search">查询</el-button>
          <el-button @click="empty">重置</el-button>
          <toolbar class="mgl10" :buttonList="buttonList_toolBar" @callFunction="callFunction"></toolbar>
        </div>
      </el-form-item>
    </el-form>
    <el-table :data="tableList" highlight-current-row element-loading-text="拼命加载中"
      element-loading-spinner="el-icon-loading" element-loading-background="rgba(0, 0, 0, 0.8)"
      @current-change="selectCurrentRow" style="width: 100%" border>
      <el-table-column prop="skuId" label="商品skuId" min-width="100" align="center"></el-table-column>
      <el-table-column prop="skuPropertyDisplay" label="sku规格" min-width="150" align="center"></el-table-column>
      <el-table-column prop="productName" label="商品名称" min-width="100" align="center"></el-table-column>
      <el-table-column prop="productModel" label="商品型号" min-width="150" align="center"></el-table-column>
      <el-table-column prop="stock" label="库存总量" min-width="150" align="center"></el-table-column>
      <el-table-column label="所属仓库" min-width="150" align="center">
        <template slot-scope="scope">
          <el-tag style="margin: 0 5px;" v-for="(item, index) in scope.row.warehouses" :key="index">
            {{ item }}
          </el-tag>
        </template>
      </el-table-column>
      <el-table-column label="操作" align="center" min-width="70" fixed="right">
        <template slot-scope="scope">
          <el-button size="mini" v-for="(item, index) in buttonList_table" :key="index" :type="item.buttonType"
            @click="callFunctionRow(item, index, scope.row)">{{ item.displayName }}</el-button>
        </template>
      </el-table-column>
    </el-table>
    <el-pagination class="pagination" layout="total, sizes, prev, pager, next, jumper" :total="total"
      :current-page="queryForm.pageIndex" :pageSize="queryForm.pageSize" @current-change="handleCurrentChange"
      @size-change="handleSizeChange"></el-pagination>
    <el-dialog :title="isEdit ? '编辑' : '新增'" :visible.sync="warehouseFormVisible" v-if="warehouseFormVisible"
      v-model="warehouseFormVisible" :close-on-click-modal="false">
      <el-form :model="warehouseForm" label-width="120px" :rules="warehouseFormRules" ref="warehouseForm">
        <el-form-item label="仓库名" prop="name">
          <el-input v-model="warehouseForm.name" auto-complete="off"></el-input>
        </el-form-item>
        <el-form-item label="所在省份" prop="area">
          <el-cascader ref="myCascader" @change="changeSelectArea" clearable style="width: 500px;"
            v-model="warehouseForm.area" :props="props"></el-cascader>
        </el-form-item>
        <el-form-item label="仓库详细地址" prop="address">
          <el-input v-model="warehouseForm.address" auto-complete="off"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click.native="warehouseFormVisible = false">取消</el-button>
        <el-button type="primary" @click.native="submitWarehouse" :loading="submitLoading">提交</el-button>
      </div>
    </el-dialog>
    <el-dialog id="areaSet" title="发货区域配置" :visible.sync="areaSetFormVisible" v-if="areaSetFormVisible"
      v-model="areaSetFormVisible" :close-on-click-modal="false" width="50%">
      <el-form :model="areaSetForm" label-width="120px" :rules="areaSetFormRules" ref="warehouseForm">
        <el-tree ref="tree" :props="props2" :load="loadNode" lazy show-checkbox @check-change="handleCheckChange">
        </el-tree>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click.native="areaSetFormVisible = false, areaList = []">取消</el-button>
        <el-button type="primary" @click.native="submitAreaSet" :loading="submitLoading">提交</el-button>
      </div>
    </el-dialog>

    <!-- 库存导入 -->
    <el-dialog title="库存导入" width="50%" :visible.sync="stockImportVisible" :show-file-list="false"
      :close-on-click-modal="false" v-if="stockImportVisible">
      <div class="updata_view" v-loading="uploading" element-loading-text="正在上传...">
        <el-upload class="upload-demo" drag action="#" :auto-upload="false" :on-change="updataLogistics" :limit='1'
          :on-exceed="fileLimit" :before-remove="delFile">
          <i class="el-icon-upload"></i>
          <div class="el-upload__text">
            将文件拖到此处，或
            <em>点击上传</em>
          </div>
          <div class="el-upload__tip" slot="tip">
            只能上传xlsx文件
            <el-button type="text" @click="upDataInfo()">下载导入模板</el-button>
          </div>
        </el-upload>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="handleExpSubmit()">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
import { getButtonList } from "../../promissionRouter";
import toolbar from "../../components/Toolbar";
import {
  GetAllInventory,
  UploadInventory,
  CreateWarehouse,
  GetAreaTree,
  GetAllArea
} from "../../api/api";
export default {
  components: {
    toolbar
  },
  data() {
    let that = this;
    return {
      props: {
        lazy: true,
        lazyLoad(node, resolve) {
          that.renderArea(resolve, node.level, node);
        },
      },
      buttonList_toolBar: [],
      buttonList_table: [],
      tableList: [],
      tableLoading: false,
      currentRow: null,
      total: 0,
      queryForm: {
        skuId: null,
        Model: null,
        warehouseName: null,
        pageIndex: 1,
        pageSize: 10
      },

      warehouseFormVisible: false,
      isEdit: false,
      warehouseForm: {
        name: null,
        area: null,
        address: null
      },
      warehouseFormRules: {
        name: [
          { required: true, message: '请输入仓库名', trigger: 'blur' },
          { message: '请输入仓库名', trigger: ['blur', 'change'] }
        ],
        area: [
          { type: 'array', required: true, message: '请选择所在省份', trigger: 'change' }
        ],
        address: [
          { required: true, message: '请输入详细地址', trigger: 'blur' },
          { message: '请输入详细地址', trigger: ['blur', 'change'] }
        ],
      },

      areaSetFormVisible: false,
      isEdit: false,
      areaSetForm: {
        name: null,
        area: null,
        address: null
      },
      areaSetFormRules: {
      },

      submitLoading: false,

      selectArea: null,


      props2: {
        label: 'label',
        children: 'children',
        isLeaf: 'leaf'
      },

      areaList: [],
      tempArr: [],


      stockImportVisible: false,
      file: null,
      uploading: false,
    };
  },
  created() {
    let routers = window.localStorage.router
      ? JSON.parse(window.localStorage.router)
      : [];
    var buttonList = getButtonList(this.$route.path, routers);
    console.log(buttonList, 'eeeee')
    const toolBarButtonList = buttonList.filter((item) => {
      return item.buttonShow === 10;
    });
    this.buttonList_toolBar = toolBarButtonList;

    const tableButtonList = buttonList.filter((item) => {
      return item.buttonShow === 20;
    });
    this.buttonList_table = tableButtonList;
  },
  mounted() {
    this.getTableList();
  },
  methods: {
    delFile() {
      this.file = null;
    },
    fileLimit() {
      this.$message.error("一次最多只能上传一份文件");
    },
    callFunction(item) {
      this[item.buttonFunc](this, item);
    },
    callFunctionRow(item, index, row) {
      this[item.buttonFunc](item, index, row);
    },
    stockImport() {
      this.stockImportVisible = true;
      this.file = null;
    },
    handleDetail(item, index, row) {
      this.skuId = row.SkuId;
      this.areaVisible = true;
    },
    updataLogistics(e) {
      let that = this;
      let index1 = e.raw.name.lastIndexOf(".") + 1;
      let index2 = e.raw.name.length;
      let type = e.raw.name.substring(index1, index2);
      if (type != "xlsx")
        return that.$message.error("请上传文件格式为xlsx文件");
      that.file = e.raw;
    },
    upDataInfo() {
      window.open(
        "https://ksaximg.ksaxshop.com/%E5%BA%93%E5%AD%98%E5%AF%BC%E5%85%A5.xlsx"
      );
    },
    handleExpSubmit(index) {
      if (!this.file) {
        return this.$message.error("请上文文件");
      }
      let that = this;
      that.uploading = true;
      let formData = new window.FormData();
      formData.append("file", that.file);
      UploadInventory(formData).then((res) => {
        if (res.data.success) {
          that.$message.success('上传成功！');
          that.uploading = false;
          that.stockImportVisible = false;
          this.getTableList()
          // that.getProduct_MultistageStockSkuList();
        } else {
          that.$message.error(res.data.error.message);
          that.uploading = false;
        }
      });
    },

    handleCheckChange(data, checked, indeterminate) {
      let checkedNodes = this.$refs.tree.getCheckedNodes(false, true)
      console.log(data, checked, indeterminate);
    },
    handleNodeClick(data) {
      console.log(data);
    },
    // 递归封装菜单树
    loopMenuTree(data, level) {
      var newData = data.filter(x => x.data.Level !== level)
      newData.forEach(x => {
        x.id = x.data.Id;
        x.value = x.data.Id;
        x.label = x.data.Name;
        x.ParentId = x.data.ParentId;
        x.Level = x.data.Level;
        x.leaf = x.Level > 2;
        x.areaFullId = [x.ParentId, x.id].join(",");
        delete x.data
        if (x.Level == 3) {
          delete x.children
        }
        return x.children && this.loopMenuTree(x.children, level)
      })
      return newData;
    },
    loopMenuTree2(data, level, id) {
      let that = this;
      var newData = data.filter(x => x.Level <= level)
      newData.forEach(x => {
        if (x.ParentId == id) {
          that.tempArr.push(x);
        }
        return x.children && this.loopMenuTree2(x.children, level, id)
      })
      return that.tempArr;
    },
    loadNode(node, resolve) {
      let that = this;
      let params;
      if (node.level == 0) {
        params = { ParentId: 0, SkipCount: 0, MaxResultCount: 40 };
        GetAllArea(params).then((res) => {
          let arr = res.data.result.items.map((e) => ({ id: e.id, value: e.id, label: e.name, leaf: node.level >= 2 }));
          resolve(arr);
        });
      }
      if (node.level == 1) {
        params = { Id: node.data.id, SkipCount: 0, MaxResultCount: 40 };
        GetAreaTree(params).then((res) => {
          let test = this.loopMenuTree(res.data.result.children, 4);
          that.areaList.push(test);
          that.tempArr = [];
          let arr = this.loopMenuTree2(test, 2, node.data.id);
          let test2 = arr.map((e) => ({ id: e.id, value: e.id, label: e.label, leaf: e.leaf, ParentId: e.ParentId, Level: e.Level, areaFullId: e.areaFullId }));
          resolve(test2);
        });
      }
      if (node.level == 2) {
        let areaList2 = that.areaList.filter(x => x[0].id == node.data.ParentId)[0]
        that.tempArr = [];
        let arr = that.loopMenuTree2(areaList2, 3, node.data.id);
        resolve(arr);
      }
    },

    changeSelectArea() {
      this.selectArea = this.$refs.myCascader.getCheckedNodes()[0].pathNodes;
    },
    renderArea(resolve, level, node) {
      let params;
      if (level == 0) {
        params = { parentId: 0 };
      } else {
        params = { parentId: node.data.id };
      }
      GetAllArea(params).then((res) => {
        let arr = res.data.result.items.map((e) => ({ id: e.id, value: e.id, label: e.name, leaf: level >= 2 }));
        resolve(arr);
      });
    },
    getTableList() {
      this.tableLoading = true;
      let params = {
        skuId: this.queryForm.skuId,
        Model: this.queryForm.Model,
        warehouseName: this.queryForm.warehouseName,
        SkipCount: (this.queryForm.pageIndex - 1) * 10,
        MaxResultCount: this.queryForm.pageSize
      }
      let that = this;
      that.tableLoading = true;
      GetAllInventory(params).then((res) => {
        that.tableLoading = false;
        that.total = res.data.result.totalCount;
        that.tableList = res.data.result.items;
      });
    },
    selectCurrentRow(val) {
      this.currentRow = val;
    },
    handleCurrentChange(val) {
      this.queryForm.pageIndex = val;
      this.getTableList();
    },
    handleSizeChange(val) {
      this.queryForm.pageSize = val;
      this.getTableList();
    },
    search() {
      this.queryForm.pageIndex = 1;
      this.queryForm.pageSize = 10;
      this.getTableList();
    },
    empty() {

      this.queryForm.skuId = null;
      this.queryForm.Model = null;
      this.queryForm.warehouseName = null;
      this.queryForm.pageIndex = 1;
      this.queryForm.pageSize = 10;
      this.getTableList();
    },
    expWarehouseId() { },
    submitWarehouse() {
      let that = this;
      that.$refs.warehouseForm.validate((valid) => {
        if (valid) {
          that.$confirm("确认提交吗？", "提示", {
            closeOnClickModal: false,
          }).then(() => {
            that.submitLoading = true;
            let provinceInfo = this.selectArea[0];
            let cityInfo = this.selectArea[1];
            let districtInfo = this.selectArea[2];
            let params = {
              name: that.warehouseForm.name,
              provinceId: provinceInfo.value,
              province: provinceInfo.label,
              cityId: cityInfo.value,
              city: cityInfo.label,
              districtId: districtInfo.value,
              district: districtInfo.label,
              detailedAddress: that.warehouseForm.address
            };
            CreateWarehouse(params).then((res) => {
              that.submitLoading = false;
              if (res.data.success) {
                that.$message.success('新增成功');
                that.warehouseFormVisible = false;
                that.getTableList();
              } else {
                that.$message.error(res.data.msg);
              }
            });
          }).catch(() => { });
        }
      });
    },

    areaSet() {
      this.areaSetFormVisible = true;
    },

    submitAreaSet() {
      let submitData = [];
      let selectList = this.$refs.tree.getCheckedNodes(false, true);
      submitData.push(selectList);
      if (!selectList.slice(-1)[0].leaf) {
        let params = { Id: selectList.slice(-1)[0].id };
        GetAllArea(params).then((res) => {
          let arr = res.data.result.items.map((e) => ({ id: e.id, value: e.id, label: e.name, leaf: node.level >= 2 }));
          resolve(arr);
        });
      }
    },
    detail(item, index, row) {
      this.$router.push(
        `/Warehouse/InventoryDetail?id=${row.id}&skuId=${row.skuId}`
      );
    },
  }
};
</script>
<style scoped>
#main-box {
  width: 100%;
  height: 100%;
  padding-top: 90px;
}

#btn-box {
  position: fixed;
  height: 110px;
  top: 94px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  padding-left: 20px;
  padding-top: 5px;
}

#btn-box /deep/ .el-form-item {
  margin-bottom: 10px;
}

#content-box {
  padding: 0 20px 20px 20px;
  width: 100%;
  height: 100%;
  overflow: auto;
}

#main-box /deep/ .el-pagination {
  padding: 10px 5px;
}

.updata_view {
  display: flex;
  justify-content: center;
  align-items: center;
}
</style>
